import React from 'react';

// Simple themed modal for success, warning, and error alerts
function AlertModal({ open, type = 'info', title, message, onClose }) {
  if (!open) return null;

  const typeToColors = {
    success: { bg: '#f3e8ff', border: '#7c3aed', text: '#4c1d95' },
    warning: { bg: '#fff7ed', border: '#f59e0b', text: '#92400e' },
    error: { bg: '#fef2f2', border: '#ef4444', text: '#7f1d1d' },
    info: { bg: '#eef2ff', border: '#6366f1', text: '#312e81' },
  };

  const colors = typeToColors[type] || typeToColors.info;

  return (
    <div className="modal-overlay" style={{ backgroundColor: 'rgba(0,0,0,0.35)' }}>
      <div
        className="modal-content"
        style={{
          maxWidth: 480,
          border: `2px solid ${colors.border}`,
          backgroundColor: colors.bg,
        }}
      >
        <h3 style={{ color: colors.text, marginBottom: 8 }}>
          {title || (type === 'success' ? 'Sucesso' : type === 'warning' ? 'Aviso' : type === 'error' ? 'Erro' : 'Informação')}
        </h3>
        <p style={{ color: colors.text, marginBottom: 16 }}>{message}</p>
        <div className="button-container">
          <button type="button" className="button-style" onClick={onClose}>
            Ok
          </button>
        </div>
      </div>
    </div>
  );
}

export default AlertModal;


